import { render, staticRenderFns } from "./OrderMeta.vue?vue&type=template&id=37ee2ecb&"
import script from "./OrderMeta.vue?vue&type=script&lang=js&"
export * from "./OrderMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports